const C = {
  name: "Car",
  dimensions: { width: 24, height: 24 },
  content: `
<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M14 5H10V7H14V5Z" fill="currentColor"/>
<path d="M7 15C7.55228 15 8 14.5523 8 14C8 13.4477 7.55228 13 7 13C6.44772 13 6 13.4477 6 14C6 14.5523 6.44772 15 7 15Z" fill="currentColor"/>
<path d="M17 15C17.5523 15 18 14.5523 18 14C18 13.4477 17.5523 13 17 13C16.4477 13 16 13.4477 16 14C16 14.5523 16.4477 15 17 15Z" fill="currentColor"/>
<path d="M5.65105 4.27239L4.19161 10.1102C2.92742 10.4631 2 11.6232 2 13V18H4V22H10V18H14V22H20V18H22V13C22 11.6232 21.0725 10.463 19.8082 10.1101L18.3488 4.27239C18.0149 2.93689 16.815 2 15.4384 2H8.56148C7.18488 2 5.98493 2.93689 5.65105 4.27239ZM8.56148 4H15.4384C15.8972 4 16.2972 4.3123 16.4085 4.75746L17.7192 10H6.2807L7.59134 4.75746C7.70263 4.3123 8.10261 4 8.56148 4ZM16 18H18V20H16V18ZM20 16H4V13C4 12.4477 4.44772 12 5 12H19C19.5523 12 20 12.4477 20 13V16ZM6 18H8V20H6V18Z" fill="currentColor"/>
</svg>
  `
};
export {
  C as Car
};
